import React from "react";
// import { retailerService } from "../../../Services";
import Select from "react-select";
import EnquiryService from "../../../Services/EnquiryService";
import EnquiryHelper from "./EnquiryHelper";
export default function Retailer({ setDetail, detail, setsales, setamount, totaldeliver, setpercentvalue, setFreight, totalFreightService, retailerList }) {

  const retailerHandler = (event) => {
    let salesObj = {}
    if (event.value === "none") {
      setDetail({
        ...detail,
        sales_person: "",
        retailer_name: event.label,
        referral_code: "",
        retailer_id: "",
      });
    } else {
      retailerList &&
      // eslint-disable-next-line
        retailerList.find((val) => {
          if (event.label === val.label) {
            salesObj = val.value.contact_name;
          }
        });
      setDetail({
        ...detail,
        sales_person: salesObj,
        retailer_name: event.label,
        referral_code: event.value.referral_token,
        retailer_id: event.value._id,
      });

      let postToken = {
        referral_token: event.value.referral_token,
      };
      EnquiryService.productReferralCode(postToken).then((res) => {
        if (res.status === true) {
          let discountAmt = EnquiryHelper.getDiscountbyPercentage(res.data.customer_discount, totalFreightService || totaldeliver);
          setamount(discountAmt);
          setpercentvalue(res.data.customer_discount);
          let finalAmount = Number(totalFreightService || totaldeliver) - Number(discountAmt);
          setFreight(finalAmount);
          // setFreight(discountAmt?.total_discount)
        }
      });

    }
  };

  return (
    <div className="mb-3 col-2">
      <label className="form-label">Retailer Name</label>
      <Select
        options={retailerList}
        styles={{
          valueContainer: (provided) => ({
            ...provided,
            height: "calc(2.15rem + 2px)",
            overflowY: "visible",
          }),
          control: (provider) => ({
            ...provider,
            borderColor: "#d8dbe0",
            boxShadow: "0 0 0 0px #d8dbe0",
          }),
          placeholder: (provider) => ({
            ...provider,
            color: "#d8dbe0",
          }),
        }}
        // eslint-disable-next-line
        value={retailerList.find((item) => {
          if (item.label === detail.retailer_name) {
            return item;
          }
        })}
        onChange={(e) => retailerHandler(e)}
      />
    </div>
  )
}